import FormHandler from "./ahx-wcpl-ajax-form.js";

const editListCloseLink = document.getElementById("edit_list_close_link"),
    listHeader = document.getElementById("list_header"),
    editListWrap = document.getElementById("edit_list_wrap"),
    editListBtn = document.getElementById("edit_list_btn"),
    listTitle = document.getElementById("list_title"),
    listDescription = document.getElementById("list_description");

export default class EditListHandler extends FormHandler {
    constructor(formElement) {
        super(formElement);

        this.editListLink = document.getElementById("edit_list_link");
        this.editListLink?.addEventListener(
            "click",
            this.openEditList.bind(this)
        );

        editListCloseLink?.addEventListener(
            "click",
            this.closeEditList.bind(this)
        );

        editListBtn?.addEventListener(
            "click",
            this.submitEditListForm.bind(this)
        );
    }

    async submitEditListForm(e) {
        try {
            this.showFullPageSpinner();

            const submitEvent = new SubmitEvent("submit", {
                submitter: e.target,
            });

            const response = await super.submitForm(submitEvent);

            this.closeEditList(e);

            listDescription.innerHTML = response.list_description;
            listTitle.innerHTML = response.list_title;
        } catch (error) {
            console.error(error);
        } finally {
            this.hideFullPageSpinner();
        }
    }

    openEditList(e) {
        e.preventDefault();
        listHeader.classList.add("d-none");
        editListWrap.style.display = "flex";
    }

    closeEditList(e) {
        e.preventDefault();
        listHeader.classList.remove("d-none");
        editListWrap.style.display = "none";
    }
}
